import {
  AfterContentChecked,
  AfterContentInit,
  AfterViewInit, ChangeDetectionStrategy,
  Component,
  DoCheck, EventEmitter,
  Input,
  OnDestroy,
  OnInit, Output,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import {DropDownTreeComponent} from '@syncfusion/ej2-angular-dropdowns';
import {DonVi} from '../../../models/danhmuc/donvi';
import {DonViService} from '../../../service/danhmuc/service-donvi';

@Component({
  selector: 'ui-select-group-inner',
  templateUrl: './groupinner.component.html',
  encapsulation: ViewEncapsulation.None
})
export class GroupInnerComponent  implements  OnInit {
  @Input() defaultValue: string[] = [];
  @Input() placeHolder: string;
  @Input() groupInnerId: string = "gId";
  @Output() changeSelect: EventEmitter<string> = new EventEmitter();
  public fieldTree: Object;
  public dataTree: DonVi[];
  public dataDonVi: Object[] = [];
  @Input() selectMulti: boolean = false;
  private filterType: String ="Contains";
  @ViewChild('treeSelect')
  public selectTree: DropDownTreeComponent;
  constructor(public donViService: DonViService

  ) {

  }
  ngOnInit(): void {
    this.donViService.getAllByActive(1).subscribe(x => {
      this.dataTree = x;
      this.dataDonVi = [];
      for (let i = 0; i < this.dataTree.length; i++) {
        this.dataDonVi.push(
          this.dataTree[i].maCapTren == 0 ?
            {
              id: this.dataTree[i].id,
              name: this.dataTree[i].tenCQ,
              hasChild: this.dataTree[i].hasChild,
              expanded: true
            }
            :
            {
              id: this.dataTree[i].id,
              pid: this.dataTree[i].maCapTren,
              name: this.dataTree[i].tenCQ,
              hasChild: this.dataTree[i].hasChild,
              expanded: false
            });
      }
      this.fieldTree = {dataSource: this.dataDonVi, value: 'id', text: 'name', parentValue: "pid", hasChildren: 'hasChild' };

    });

    setTimeout (() => {
      this.selectTree.value = this.defaultValue;
    }, 1000);
  }

}
